import React, { useState } from 'react'
import { Modal } from "react-bootstrap";
import { IoPrintOutline } from 'react-icons/io5';
import { FaFilePdf, FaImage } from 'react-icons/fa'
import { formatDateToDDMMYYYY } from '../../common/DateUtils';

export default function PdfRenderComponent({
    relativesList,
    userDatas,
    recommend1,
    recommend2,
    emergency,
    formName,
    pdfRef,
    onClose,
    onSubmit,
    files,
    showSubmitButton = false,
    handleSubmit = null,
    isPdfMode = false,
    witness1,
    witness2,
    refer
}) {
    const [showpdf, setShowPdf] = useState(null)
    const [imageErrors, setImageErrors] = useState(new Set());

    // Helper function to handle image loading errors
    const handleImageError = (imageSrc) => {
        setImageErrors(prev => new Set(prev).add(imageSrc));
    };

    const handlePdfOpen = (value) => {
        try {
            if (value && typeof value === 'object' && value.file instanceof File) {
                const url = URL.createObjectURL(value.file);
                setShowPdf(url);
            }
            else if (value instanceof File) {
                const url = URL.createObjectURL(value);
                setShowPdf(url);
            } else if (typeof value === "string" && (value.startsWith("http") || value.includes("."))) {
                setShowPdf(value);
            }
            else if (value && typeof value === 'object' && value.url) {
                setShowPdf(value.url);
            } else {
                setShowPdf(null);
            }
        }
        catch (error) {
            console.error('Error opening PDF:', error);
            setShowPdf(null);
        }

    };

    const handlePrint = () => {
        const printContent = document.getElementById('printable-content').innerHTML;
        const printWindow = window.open('', '_blank', 'width=800,height=600');
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
                <head>
                    <title>${formName || 'Assessment Form'}</title>
                    <style>
                        body {
                            font-family: Arial, sans-serif;
                            margin: 20px;
                            line-height: 1.4;
                        }
                        .preview-title h3 {
                            text-align: center;
                            margin-bottom: 30px;
                            font-size: 18px;
                        }
                        .preview-section {
                            margin-bottom: 25px;
                            page-break-inside: avoid;
                        }
                        .preview-section-title {
                            border-bottom: 2px solid #333;
                            padding-bottom: 5px;
                            margin-bottom: 15px;
                            font-size: 16px;
                            font-weight: bold;
                        }
                        .info-grid {
                            display: grid;
                            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                            gap: 15px;
                            margin-bottom: 20px;
                        }
                        .info-row {
                            display: flex;
                            flex-direction: column;
                            gap: 5px;
                        }
                        .info-grid .label,
                        .sub-title {
                            font-size: 14px;
                            font-weight: 600;
                            color: #333;
                        }
                        .witnesses-section {
                            margin-bottom: 20px;
                        }
                        .witness-info {
                            margin-bottom: 20px;
                            padding: 15px;
                            border: 1px solid #ddd;
                            border-radius: 5px;
                        }
                        .sub-title {
                            font-weight: bold;
                            margin-bottom: 10px;
                            color: #555;
                        }
                        .text-section {
                            margin-bottom: 15px;
                            padding: 10px;
                            background-color: #f9f9f9;
                            border-left: 3px solid #007bff;
                        }
                        .text-section p {
                            margin: 0;
                            line-height: 1.5;
                        }
                             .profile-image {
                            width: 120px;
                            height: 120px;
                            object-fit: cover;
                            border-radius: 8px;
                            border: 1px solid #ddd;
                        }
                        @media print {
                            body { margin: 0; }
                            .preview-section { page-break-inside: avoid; }
                        }
                    </style>
                </head>
                <body>
                    ${printContent}
                </body>
            </html>
        `);

        printWindow.document.close()
        printWindow.focus()
        printWindow.print()
        printWindow.close()
    };
    
    const getExtraFormConfig = (formName) => {
        if (formName === 'Admission Form') {
            return {
                basicInfo: {
                    title: 'Basic Information',
                    type: 'info_grid',
                    fields: [
                        { label: 'Enquiry Number', key: 'pv_enquiry_number' },
                        { label: 'Enquiry Date', key: 'enquiry_date' },
                        { label: 'Admission Date', key: 'admission_date' },
                        { label: 'Admission Number', key: 'pv_admission_number' },
                    ]
                },
                personalInfo: {
                    title: 'Personal Information',
                    type: 'info_grid',
                    fields: [
                        { label: 'First Name', key: 'first_name' },
                        { label: 'Last Name', key: 'last_name' },
                        { label: 'Gender', key: 'gender' },
                        { label: 'Address', key: 'address' },
                        { label: 'Marital Status', key: 'marital_status' },
                        { label: 'Age', key: 'age' },
                        { label: 'Mobile Number', key: 'mobile_number' },
                        { label: 'Religion', key: 'religion' },
                        { label: 'Caste', key: 'caste' },
                        { label: 'Education', key: 'education' },
                        { label: 'Occupied Job', key: 'job' },
                    ]
                },
                identificationInfo: {
                    title: 'Identification Information',
                    type: 'info_grid',
                    fields: [
                        { label: 'Identity Card Type', key: 'idcard_type' },
                        { label: 'Identity Card Number', key: 'idcard_no' },
                        { label: 'Bank Account', key: 'bank_account' },
                        { label: 'Source of Income', key: 'own_income' },
                    ]
                },
                roomAndLicense: {
                    title: 'Room & License Information',
                    type: 'info_grid',
                    fields: [
                        { label: 'Room/Bed Unit', key: 'bedunit_code' },
                        { label: 'License/Programme', key: 'license' },
                        { label: 'Basis for Admission', key: 'basis_for_admission' },
                    ]
                },
                witnessInfo: {
                    title: 'Witness Information',
                    type: 'witnesses',
                    fields: []
                },
                guardianInfo: {
                    title: 'Guardian Information',
                    type: 'info_grid',
                    fields: [
                        { label: 'Guardian Name', key: 'guardian_name' },
                        { label: 'Guardian Address', key: 'guardian_address' },
                        { label: 'Guardian Contact', key: 'guardian_contact' },
                        { label: 'Guardian Signature', key: 'guardian_sign' },
                    ]
                },
                signatures: {
                    title: 'Signatures & Documents',
                    type: 'info_grid',
                    fields: [
                        { label: 'Resident Signature', key: 'admission_consent_form' },
                    ]
                }
            };
        }
        else if (formName === 'Enquiry Form') {
            let config = {
                userData: {
                    title: 'User Profile',
                    type: 'info_grid',
                    fields: [
                        { label: 'Enquiry Number', key: 'pv_enquiry_number' },
                        { label: 'Enquiry Date', key: 'enquiry_date' },
                        { label: 'First Name', key: 'firstname' },
                        { label: 'Last Name', key: 'lastname' },
                        { label: 'Father/Mother Name', key: 'parent' },
                        { label: 'Phone', key: 'phone.mobile_number' },
                        { label: 'Email', key: 'email' },
                        { label: 'Date of Birth', key: 'dob' },
                        { label: 'Age', key: 'age' },
                        { label: 'Gender', key: 'gender' },
                        { label: 'Identity Card', key: 'identitycard.value' },
                        { label: 'Identity Card Number', key: 'identitynumber' },
                        { label: 'Marital Status', key: 'marital_status' },
                        { label: 'AddressLine 1', key: 'city' },
                        { label: 'AddressLine 2', key: 'province' },
                        { label: 'AddressLine 3', key: 'location' },
                        { label: 'Country', key: 'country' },
                        { label: 'Region', key: 'state' },
                        { label: 'Pincode', key: 'pincode' },
                        { label: 'Do you own a home?', key: 'is_home' },
                        { label: 'Is your father/mother alive?', key: 'is_aliveparent' },
                        { label: 'Do you own land?', key: 'own_land' },
                        { label: 'Own land Details', key: 'own_landDetails' },
                        { label: 'Are you successor of any property?', key: 'own_property' },
                        { label: 'Successor property Details', key: 'successordetails' },
                        { label: 'Is your name added in Ration Card?', key: 'own_rationcard' },
                        { label: 'Did receive any pension/insurance/other incomes?', key: 'own_income' },
                        { label: 'Other financial income Details', key: 'finincome' },
                        { label: 'Any other physical support?', key: 'physical_support' },
                        { label: 'Any police cases?', key: 'police_case' },
                        { label: 'Is there a provision for posthumous care if disabled?', key: 'post_care' },
                        { label: 'If yes, why not take over now?', key: 'post_caredetails' }
                    ]
                },
                qualitiesSection: {
                    title: 'Qualities',
                    type: 'checkbox_list',
                    data: recommend1,
                    fields: [
                        { label: 'Self Sufficient', key: 'self_sufficient' },
                        { label: 'Consciousness', key: 'consciousness' },
                        { label: 'Attention', key: 'attention' },
                        { label: 'Memory Loss', key: 'memory' },
                        { label: 'Spatial perception', key: 'spatial_perception' },
                        { label: 'Talkative', key: 'talkative' },
                        { label: 'Handicapped', key: 'handicapped' },
                        { label: 'Sight Issue', key: 'sight_issue' },
                        { label: 'Hear Issue', key: 'hear_issue' },
                        { label: 'Heterosexual', key: 'heterosexual' },
                        { label: 'Other', key: 'other' }
                    ]
                },
                weaknessSectionweaknessSection: {
                    title: 'Weakness',
                    type: 'checkbox_list',
                    data: recommend2,
                    fields: [
                        { label: 'Smoking', key: 'smoking' },
                        { label: 'Alcohol', key: 'alcohol' },
                        { label: 'Drug Addict', key: 'drug_addict' },
                        { label: 'Betel Use', key: 'betel_use' },
                        { label: 'Tobacco Use', key: 'tobacco' }
                    ]
                },
                relative: {
                    title: 'Details of Members in home',
                    type: 'info_grid',
                    fields: [
                        { label: 'Name', key: 'name' },
                        { label: 'Age', key: 'age' },
                        { label: 'Relation', key: 'relation' },
                        { label: 'Occupation', key: 'job' },
                        { label: 'Phone', key: 'phone' }
                    ]
                },
                bystanderInfo: {
                    title: 'Name of bystander if any emergency arrive',
                    type: 'info_grid',
                    fields: [
                        { label: 'Bystander Name', key: 'bystandername' },
                        { label: 'Bystander Contact', key: 'bystanderconatct' }
                    ]
                },
                medicalInfo: {
                    title: 'Medical Information',
                    type: 'info_grid',
                    fields: [
                        { label: 'Any treatments for diseases', key: 'undergoing_treatment' },
                        { label: 'Treatment place name', key: 'treatment_place' },
                        { label: 'Care details for patient', key: 'care_details' },
                        { label: 'Autobiography details', key: 'autobiography' }
                    ]
                },
                fieldFindings: {
                    title: 'Field Findings',
                    type: 'info_grid',
                    fields: [
                        { label: 'Field Report', key: 'report' }
                    ]
                },
                recommendationsSection: {
                    title: 'Recommendations',
                    type: 'recommendations_list',
                    data: refer,
                    fields: [
                        { label: 'Type', key: 'referer' },
                        { label: 'Name', key: 'name' },
                        { label: 'Contact no', key: 'phone' }
                    ]
                },
                // emergency: {
                //     title: 'Recommendations',
                //     type: 'info_grid',
                //     fields: [
                //         { label: 'Type', key: 'referer' },
                //         { label: 'Name', key: 'name' },
                //         { label: 'Contact no', key: 'phone' }
                //     ]
                // },
                fileUpload: {
                    title: 'File Uploaded',
                    type: 'info_grid',
                    fields: [
                        { label: 'Upload Report', key: 'fileName1' },
                        { label: 'Upload Consent form', key: 'fileName' },

                    ]
                }
            }
            return config;
        }
        else if (formName === 'Dialysis Application Form' || formName === 'Palliativecare Application Form' || formName === 'Physiotherapy Application Form') {
            let config = {
                profileImg: {
                    title: 'Profile Image',
                    type: 'info_grid',
                    fields: [
                        { label: 'Photo', key: 'img_url' }
                    ]
                },
                userDatas: {
                    title: 'User Profile',
                    type: 'info_grid',
                    fields: [
                        { label: 'First Name', key: 'firstname' },
                        { label: 'Last Name', key: 'lastname' },
                        { label: 'Dial Code', key: 'phone.dialcode' },
                        { label: 'Contact no', key: 'phone.rawphone' },
                        { label: 'Date of Birth', key: 'dob' },
                        { label: 'Age', key: 'age' },
                        { label: 'Gender', key: 'gender' },
                        { label: 'Apartment No', key: 'apartment_no' },
                        { label: 'Location', key: 'location' },
                        { label: 'Landmark', key: 'landmark' },
                        { label: 'Pincode', key: 'pincode' },
                        { label: 'Panchayath', key: 'panchayath' },
                        { label: 'City', key: 'city' },
                        { label: 'District', key: 'province' },
                        { label: 'State', key: 'state' },
                        { label: 'Country', key: 'country' },
                        { label: 'Occupation', key: 'occupation' },
                        { label: 'Income', key: 'income' },
                        { label: 'ID Card Type', key: 'identitycard.label' },
                        { label: 'ID Card Number', key: 'identitynumber' },
                        { label: 'Insurance Provider', key: 'insuranceprovider' },
                        { label: 'Insurance Number', key: 'insurancenumber' },
                        { label: 'Distance', key: 'distance' },
                    ]
                },
                relative: {
                    title: 'Family Details',
                    type: 'info_grid',
                    fields: [
                        { label: 'Name', key: 'name' },
                        { label: 'Relation', key: 'relation' },
                        { label: 'Contact', key: 'contact' },
                        { label: 'Occupation', key: 'occupation' },
                        { label: 'Income', key: 'income' }
                    ]
                },
                medicalInfo: {
                    title: 'Medical Information',
                    type: 'info_grid',
                    fields: []
                },
                recommend1: {
                    title: 'Recommendation 1',
                    type: 'info_grid',
                    fields: [
                        { label: 'Name', key: 'name' },
                        { label: 'Designation', key: 'relation' },
                        { label: 'Contact', key: 'contact' }
                    ]
                },
                recommend2: {
                    title: 'Recommendation 2',
                    type: 'info_grid',
                    fields: [
                        { label: 'Name', key: 'name' },
                        { label: 'Designation', key: 'relation' },
                        { label: 'Contact', key: 'contact' }
                    ]
                },
                referralInfo: {
                    title: 'Referral Information',
                    type: 'info_grid',
                    fields: [
                        { label: 'Name of physician or health provider', key: 'referral_name' },
                    ]
                },
                emergency: {
                    title: 'Emergency Contact',
                    type: 'info_grid',
                    fields: [
                        { label: 'Name', key: 'name' },
                        { label: 'Relation', key: 'relation' },
                        { label: 'Contact', key: 'contact' },
                        { label: 'Secondary Contact', key: 'secondary_contact' }
                    ]
                },
                fileUpload: {
                    title: 'File Uploaded',
                    type: 'info_grid',
                    fields: [
                        { label: 'Upload Prescription', key: 'medical_prescription' },
                        { label: 'Referral Consent', key: 'referral_document' },
                        { label: 'Recommendations', key: 'files' }
                    ]
                }
            };

            if (formName === 'Dialysis Application Form') {
                config.medicalInfo.fields.push(
                    { label: 'What is the total expense incurred on medication?', key: 'med_expense' },
                    { label: 'Have you undergone a kidney transplantation?', key: 'prev_kidney_transplant' },
                    { label: 'Have you undergone a blood transfusion?', key: 'prev_blood_transfusion' },
                    { label: 'Duration of dialysis treatment', key: 'prev_dialysis' }
                );
            }
            if (formName === 'Palliativecare Application Form') {
                config.medicalInfo.fields.push(
                    { label: 'Do you have any current medical conditions?', key: 'med_information' },
                    { label: 'Comorbidities', key: 'comorbidConditions', type: 'array' }
                );
            }
            if (formName === 'Physiotherapy Application Form') {
                config.medicalInfo.fields.push(
                    { label: 'Do you have any current medical conditions?', key: 'med_information' },
                    { label: 'Duration of physiotherapy treatment', key: 'duration' },
                    { label: 'Type of therapy', key: 'therapy_type' }
                );
            }
            if (formName === 'Dialysis Application Form') {
                config.fileUpload.files = files;
            }
            return config;
        }
        else if (formName === 'Patient Primary Enquiry') {
            let config = {
                profileImg: {
                    title: 'Profile Image',
                    type: 'info_grid',
                    fields: [
                        { label: 'Photo', key: 'img_url' }
                    ]
                },
                userData: {
                    title: 'User Profile',
                    type: 'info_grid',
                    fields: [
                        { label: 'Enquiry Number', key: 'pv_enquiry_number' },
                        { label: 'PE Date', key: 'pe_date' },
                        { label: 'First Name', key: 'firstname' },
                        { label: 'Last Name', key: 'lastname' },
                        { label: 'Date of Birth', key: 'dob' },
                        { label: 'Age', key: 'age' },
                        { label: 'Gender', key: 'gender' },
                        { label: 'Phone', key: 'phone.mobile_number' },
                        { label: 'Email', key: 'email' },
                        { label: 'Identity Card', key: 'identitycard.value' },
                        { label: 'Identity Card Number', key: 'identitynumber' },
                        { label: 'AddressLine 1', key: 'city' },
                        { label: 'AddressLine 2', key: 'province' },
                        { label: 'AddressLine 3', key: 'location' },
                        { label: 'Country', key: 'country' },
                        { label: 'Region', key: '' },
                        { label: 'Pincode', key: 'pincode' },
                    ]
                },
                recommend1: {
                    title: 'Referrer 1',
                    type: 'info_grid',
                    fields: [
                        { label: 'Name', key: 'name' },
                        { label: 'Contact no', key: 'contact' },
                        { label: 'Comments', key: 'comments' }
                    ]
                },
                recommend2: {
                    title: 'Referrer 2',
                    type: 'info_grid',
                    fields: [
                        { label: 'Name', key: 'name' },
                        { label: 'Contact no', key: 'contact' },
                        { label: 'Comments', key: 'comments' }
                    ]
                }
            }
            return config;
        }

        return {
            defaultSection: {
                title: 'Form Data',
                type: 'info_grid',
                fields: []
            }
        };
    };

    const getValue = (obj, key, label = '') => {
        try {
            const keys = key.split(".");
            let value = obj;
            for (const k of keys) {
                value = value?.[k];
            }
            if ((key === 'age' || label.toLowerCase() === 'age') && formName === 'Admission Form') {
                if (value && (typeof value === 'string' && value.includes('-'))) {
                    return calculateAgeFromDob(value);
                }
                return formatValue(value);
            }
            if (key === 'license') {
                if (value === 1) return 'Women in Distress'
                else if (value === 2) return 'Old age home for women'
                else if (value === 3) return 'old age home for men'

            }

            const dateLabels = ['enquiry date', 'admission date', 'date of birth', 'pe date', 'dob'];
            const shouldFormatAsDate = dateLabels.some(dateLabel =>
                label.toLowerCase().includes(dateLabel)
            );

            if (shouldFormatAsDate && value) {
                return formatDateToDDMMYYYY(value);
            }

            if (key.startsWith("phone.") && value) {
                return value || "-";
            }

            if (key === "identitycard.label" && value) {
                return value || "-";
            }

            if (key.toLowerCase().includes("contact") && value) {
                return value.startsWith("+") ? value : `+${value}`;
            }

            if (key === "income" && value) {
                return `₹${value}`
            }

            return formatValue(value);

        }
        catch (error) {
            console.error(`Error getting value for key ${key}:`, error);
            return "- -";
        }

    };
    const calculateAgeFromDob = (dob) => {
        if (!dob) return "- -";

        try {
            const dobDate = new Date(dob);
            const today = new Date();
            let age = today.getFullYear() - dobDate.getFullYear();
            const monthDiff = today.getMonth() - dobDate.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) {
                age--;
            }

            return age.toString();
        } catch (error) {
            console.error('Error calculating age:', error);
            return "- -";
        }
    };
    const formatValue = (val) => {
        try {
            if (val === null || val === undefined || val === "") return "- -";
            if (typeof val === "boolean") return val ? "Yes" : "No";
            if (val instanceof File) {
                return val.name; // Always return the filename, not the File object
            }
            if (typeof val === "string" && (val.startsWith("http") || val.endsWith(".pdf"))) {
                return isPdfMode ? "Document attached" : val;
            }
            if (Array.isArray(val)) {
                if (val.every(v => v instanceof File || typeof v === "string")) {
                    return isPdfMode ? `${val.length} file(s) attached` : val.map(v => v instanceof File ? v.name : v).join(", ");
                }
                return val.length > 0 ? val.join(", ") : "- -";
            }
            if (typeof val === "object") return "Document attached";
            return String(val);
        }
        catch (error) {
            console.error('Error formatting value:', error);
            return "- -";
        }

    };

    // Helper function to determine if a file is an image or PDF
    const getFileIcon = (file) => {
        if (!file) return null;

        let fileType = '';
        if (file instanceof File) {
            fileType = file.type;
        } else if (typeof file === 'string') {
            if (file.toLowerCase().includes('.pdf') || file.toLowerCase().includes('pdf')) {
                fileType = 'application/pdf';
            } else if (file.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp|webp)$/)) {
                fileType = 'image';
            }
        }

        if (fileType.startsWith('image/') || fileType === 'image') {
            return <FaImage size={20} color="#009996" style={{ cursor: "pointer" }} />;
        } else if (fileType === 'application/pdf' || fileType.includes('pdf')) {
            return <FaFilePdf size={20} color="#009996" style={{ cursor: "pointer" }} />;
        }

        return <FaFilePdf size={20} color="#009996" style={{ cursor: "pointer" }} />;
    };
    const ProfileImage = ({ src, alt = "Profile Image" }) => {
        if (!src || imageErrors.has(src)) {
            return (
                <div style={{
                    width: '120px',
                    height: '120px',
                    backgroundColor: '#f0f0f0',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#666',
                    fontSize: '12px'
                }}>
                    No Image
                </div>
            );
        }

        return (
            <img
                src={src}
                alt={alt}
                className="profile-image"
                style={{
                    width: '120px',
                    height: '120px',
                    objectFit: 'cover',
                    borderRadius: '8px',
                    border: '1px solid #ddd'
                }}
                onError={() => handleImageError(src)}
                crossOrigin="anonymous"
            />
        );
    };

    const config = getExtraFormConfig(formName);

    const ContentComponent = () => (
        <div id="printable-content" className="preview-content" ref={pdfRef}>
            <div className="preview-title">
                <h3>{formName || "Assessment Preview"}</h3>
            </div>

            {Object.entries(config).map(([sectionKey, section]) => (
                <div key={sectionKey} className="preview-section">
                    <h3 className="preview-section-title">{section.title}</h3>

                    {section.type === "info_grid" && (
                        <>
                            {Array.isArray(
                                sectionKey === "relative"
                                    ? relativesList

                                    : sectionKey === "recommend1"
                                        ? [recommend1]
                                        : sectionKey === "recommend2"
                                            ? [recommend2]
                                            : sectionKey === "emergency"
                                                ? [emergency]
                                                : [userDatas]
                            )
                                ? (
                                    (sectionKey === "relative"
                                        ? relativesList

                                        : sectionKey === "recommend1"
                                            ? [recommend1]
                                            : sectionKey === "recommend2"
                                                ? [recommend2]
                                                : sectionKey === "emergency"
                                                    ? [emergency]
                                                    : [userDatas]
                                    ).map((item, idx) => (
                                        <div key={idx} className="info-grid">
                                            {section.fields.map((field) => {
                                                const value = getValue(item, field.key, field.label);
                                                if (value === "- -" || value === null || value === undefined) return null;

                                                return (
                                                    <div className="info-row" key={field.key}>
                                                        <span className="label">{field.label}</span>
                                                        {(field.key === 'admission_consent_form' || field.key === 'guardian_sign') ? (
                                                            userDatas[field.key] && !isPdfMode ? (
                                                                <div onClick={() => handlePdfOpen(userDatas[field.key])} style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                                                                    {getFileIcon(userDatas[field.key])}
                                                                    <span style={{ color: '#009996', cursor: 'pointer' }}>
                                                                        View Document
                                                                    </span>
                                                                </div>
                                                            ) : isPdfMode && userDatas[field.key] ? (
                                                                <span>Document attached</span>
                                                            ) : (
                                                                <span>No document</span>
                                                            )
                                                        )

                                                            : field.key === "img_url" ? (
                                                                <ProfileImage src={value} alt="Profile" />
                                                            ) : field.key === "medical_prescription" || field.key === "referral_document" ? (
                                                                getValue(item, field.key) && getValue(item, field.key) !== "- -" && !isPdfMode ? (
                                                                    <div className="signature-item">
                                                                        <FaFilePdf
                                                                            size={18}
                                                                            color="#009996"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => handlePdfOpen(item[field.key])}
                                                                            title={`View ${field.label}`}
                                                                        />
                                                                        <span>Document attached</span>
                                                                    </div>
                                                                ) : isPdfMode ? (
                                                                    <span>Document attached</span>
                                                                ) : (
                                                                    <span>No document</span>
                                                                )
                                                            ) : field.key === 'comorbidConditions' && Array.isArray(value) ? (
                                                                <ul>{value.map((c, i) => (
                                                                    <li key={i}>{c}</li>
                                                                ))}</ul>
                                                            ) : field.key === "fileName1" || field.key === "fileName" ? (
                                                                value && value !== "Upload Report" && value !== "Upload Consent form" && !isPdfMode ? (
                                                                    <FaFilePdf
                                                                        size={24}
                                                                        color="#009996"
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => {

                                                                            if (field.key === "fileName1" && userDatas.enquiry_report) {
                                                                                handlePdfOpen(userDatas.enquiry_report);
                                                                            } else if (field.key === "fileName" && userDatas.consent_form) {
                                                                                handlePdfOpen(userDatas.consent_form);
                                                                            }
                                                                        }}
                                                                        title={value}
                                                                    />
                                                                ) : isPdfMode ? (
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                        <FaFilePdf size={16} color="#009996" />
                                                                        <span>Document attached</span>
                                                                    </div>
                                                                ) : null
                                                            ) : field.key === "files" ? (
                                                                isPdfMode ? (
                                                                    <span>{userDatas.files?.length || 0} file(s) attached</span>
                                                                ) : (
                                                                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                                                        {(userDatas.files || []).map((fileObj, i) => {
                                                                            const file = fileObj.file || fileObj;
                                                                            const fileName = fileObj.name || file?.name || `File ${i + 1}`;

                                                                            return (
                                                                                <FaFilePdf
                                                                                    size={20}
                                                                                    color="#009996"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    onClick={() => handlePdfOpen(file)}
                                                                                    title={fileName}
                                                                                />
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )
                                                            ) : (
                                                                <span>{value}</span>
                                                            )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))
                                )
                                : (
                                    <div className="info-grid">
                                        {section.fields.map((field) => {
                                            const value = getValue(userDatas, field.key, field.label);
                                            if (value === "- -" || value === null || value === undefined) return null;

                                            return (
                                                <div className="info-row" key={field.key}>
                                                    <span className="label">{field.label}:</span>
                                                    {field.key === 'admission_consent_form' || field.key === 'guardian_sign' ? (
                                                        userDatas[field.key] && !isPdfMode ? (
                                                            <div onClick={() => handlePdfOpen(userDatas[field.key])} style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                                                                {getFileIcon(userDatas[field.key])}
                                                                <span style={{ color: '#009996', cursor: 'pointer' }}>
                                                                    View Document
                                                                </span>
                                                            </div>
                                                        ) : isPdfMode && userDatas[field.key] ? (
                                                            <span>Document attached</span>
                                                        ) : (
                                                            <span>No document</span>
                                                        )
                                                    ) :
                                                        field.key === "img_url" ? (
                                                            <ProfileImage src={value} alt="Profile" />
                                                        ) : field.key === 'marital_status' ? (
                                                            <span>{value === true ? 'Married' : value === false ? 'Unmarried' : '- -'}</span>
                                                        ) : field.key === 'enquiry_date' || field.key === 'admission_date' ? (
                                                            <span>{value && value !== '- -' ? new Date(value).toLocaleDateString() : '- -'}</span>
                                                        ) : field.key === 'license' ? (
                                                            <span>{userDatas.license || '- -'}</span>
                                                        ) : (
                                                            <span>{typeof value === 'object' && value instanceof File ? value.name : value}</span>
                                                        )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                        </>
                    )}
                    {section.type === "recommendations_list" && (
                        <div className="recommendations-list">
                            {section.data && Array.isArray(section.data) && section.data.length > 0 ? (
                                section.data.map((item, idx) => (
                                    <div key={idx} className="recommendation-item" >
                                        <h5 style={{ marginBottom: '10px', color: '#555' }}>
                                            Recommendation {idx + 1}
                                        </h5>
                                        <div className="info-grid">
                                            {section.fields.map((field) => {
                                                const value = getValue(item, field.key, field.label);
                                                if (value === "- -" || value === null || value === undefined) return null;

                                                return (
                                                    <div className="info-row" key={field.key}>
                                                        <span className="label">{field.label}:</span>
                                                        <span>{value}</span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div style={{ padding: '10px', color: '#666', fontStyle: 'italic' }}>
                                    No recommendations added
                                </div>
                            )}
                        </div>
                    )}
                    {section.type === "checkbox_list" && (
                        <div className="checkbox-list">
                            {section.fields
                                .filter(field => section.data && section.data[field.key] === true)
                                .map((field) => (
                                    <div key={field.key} className="checkbox-item">
                                        <span>✓ {field.label}</span>
                                    </div>
                                ))}
                            {section.fields.filter(field => section.data && section.data[field.key] === true).length === 0 && (
                                <span>None selected</span>
                            )}
                        </div>
                    )}

                    {section.type === "witnesses" && (witness1?.name || witness2?.name) && (
                        <div className="witnesses-section">
                            {witness1 && witness1.name && (
                                <div className="witness-info">
                                    <h4 className="sub-title">Witness 1</h4>
                                    <div className="info-grid">
                                        <div className="info-row">
                                            <span className="label">Name:</span>
                                            <span>{witness1.name}</span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Contact:</span>
                                            <span>{witness1.contact}</span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Signature:</span>
                                            {userDatas.witness1_sign && !isPdfMode ? (
                                                <div onClick={() => handlePdfOpen(userDatas.witness1_sign)} style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                                                    {getFileIcon(userDatas.witness1_sign)}
                                                    <span style={{ color: '#009996', cursor: 'pointer' }}>
                                                        View Signature
                                                    </span>
                                                </div>
                                            ) : isPdfMode && userDatas.witness1_sign ? (
                                                <span>Signature attached</span>
                                            ) : (
                                                <span>No signature</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {witness2 && witness2.name && (
                                <div className="witness-info">
                                    <h4 className="sub-title">Witness 2</h4>
                                    <div className="info-grid">
                                        <div className="info-row">
                                            <span className="label">Name:</span>
                                            <span>{witness2.name}</span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Contact:</span>
                                            <span>{witness2.contact}</span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Signature:</span>
                                            {userDatas.witness2_sign && !isPdfMode ? (
                                                <div onClick={() => handlePdfOpen(userDatas.witness2_sign)} style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                                                    {getFileIcon(userDatas.witness2_sign)}
                                                    <span style={{ color: '#009996', cursor: 'pointer' }}>
                                                        View Signature
                                                    </span>
                                                </div>
                                            ) : isPdfMode && userDatas.witness2_sign ? (
                                                <span>Signature attached</span>
                                            ) : (
                                                <span>No signature</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            ))}

            {/* Guardian Declaration Section */}
            {userDatas.guardian_name && (
                <div className="preview-section">
                    <h3 className="preview-section-title">Guardian Declaration</h3>
                    <div className="text-section">
                        <p style={{ fontStyle: 'italic', marginBottom: '15px' }}>
                            "I affirm, to the best of my knowledge and belief, the accuracy of the aforementioned details.
                            I acknowledge that any consequences arising from admitting the person to Peace Village,
                            including disciplinary issues as per the institution's policies, or in the event of death,
                            I am solely prepared to accept all responsibilities."
                        </p>
                    </div>
                </div>
            )}
        </div>
    );

    if (isPdfMode) {
        return <ContentComponent />;
    }

    return (
        <>
            <Modal show={true} centered size="lg" onHide={onClose}>
                <Modal.Header closeButton />
                <Modal.Body style={{ textAlign: "left", display: "flex", flexDirection: "column" }}>
                    <ContentComponent />

                    <div className="preview-controls" style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
                        <button className="cancel-btn preview-btn" onClick={onClose}>Close</button>
                        <button onClick={handlePrint} className="preview-btn print-bttn" title="Print Preview">
                            <IoPrintOutline /> Print
                        </button>
                        {showSubmitButton && (
                            <button onClick={handleSubmit} className='preview-btn submit-btn'>Submit</button>
                        )}
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={!!showpdf} onHide={() => setShowPdf(null)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Document Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: "80vh" }}>
                    {showpdf ? (
                        <iframe
                            src={showpdf}
                            title="Document Preview"
                            width="100%"
                            height="100%"
                            style={{ border: "none" }}
                        />
                    ) : (
                        <p>No document available</p>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
}